(() => {
  const key = 'shopify-wishlist';
  const read = () => {
    try { return [...new Set((localStorage.getItem(key) || '').split(',').filter(Boolean))]; }
    catch (_) { return []; }
  };
  const sync = () => {
    const handles = read();
    document.querySelectorAll('.wishlist__count').forEach(counter => { counter.textContent = handles.length; });
    document.querySelectorAll('wishlist-item button').forEach(button => {
      const active = handles.includes(button.dataset.productHandle);
      button.classList.toggle('active', active);
      button.setAttribute('aria-pressed', String(active));
      const label = button.querySelector(active ? '.remove__wishlist' : '.add__wishlist')?.getAttribute('title');
      if (label) button.setAttribute('aria-label', label);
    });
    document.querySelector('.wishlist-page')?.classList.toggle('wishlist_exists', handles.length > 0);
  };
  class WishlistProduct extends HTMLElement {
    connectedCallback() {
      if (!this.boundWishlist) {
        this.boundWishlist = true;
        this.addEventListener('click', event => {
          const button = event.target.closest('button');
          const handle = button?.dataset.productHandle;
          if (!handle) return;
          event.preventDefault();
          const handles = read();
          const index = handles.indexOf(handle);
          if (index < 0) handles.push(handle);
          else handles.splice(index, 1);
          try {
            if (handles.length) localStorage.setItem(key, handles.join(','));
            else localStorage.removeItem(key);
          } catch (_) { return; }
          if (index >= 0 && this.closest('[grid-wishlist]')) this.closest('.product__card')?.remove();
          sync();
        });
      }
      sync();
    }
  }
  if (!customElements.get('wishlist-item')) customElements.define('wishlist-item', WishlistProduct);
  const start = async () => {
    sync();
    const grid = document.querySelector('[grid-wishlist]');
    if (!grid) return;
    const cards = await Promise.all(read().map(async handle => {
      try {
        const response = await fetch('/products/' + encodeURIComponent(handle) + '?view=wishlist');
        return response.ok ? await response.text() : '';
      } catch (_) { return ''; }
    }));
    grid.innerHTML = cards.join('');
    sync();
  };
  window.addEventListener('storage', event => { if (event.key === key) sync(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
